import React from 'react';
import { CnLayoutRow as UICnLayoutRow } from '@/components/cn-layout/index';
const CnLayoutRow = (props) => {
    const { children } = props || {};
    return <UICnLayoutRow>{children}</UICnLayoutRow>;
};
CnLayoutRow.displayName = 'CnLayoutRow';
export default CnLayoutRow;
export { CnLayoutRow };
